<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-sm table-hover inherit-link-styles">
              <thead>
                <tr>
                  <th></th>
                  <th scope="col">№</th>
                  <th scope="col">Название</th>
                  <th scope="col">Тип</th>
                  <!--<th scope="col">Артикул</th>
                  <th scope="col">Статус</th>-->
                  <th scope="col">Сумма</th>
                  <!--<th scope="col">Фильтры</th>-->
                </tr>
              </thead>
              <tbody>
                <tr
                  class="nowrap"
                  v-for="item in items"
                  :class="{
                    'unread': item.unread,
                    'unread-row': item.unread,
                    'read-row': !item.unread
                  }"
                  :style="{
                    'background-color': item.state && item.state.color
                  }"
                >
                  <td>
                    <!--
                    <b-form-checkbox
                      v-model="item._selected"
                      value="accepted"
                      unchecked-value="not_accepted"
                    >
                    </b-form-checkbox>
                    -->
                    <FunctionsBadge
                      :item="item"
                      :functions="item.functions"
                    ></FunctionsBadge>
                  </td>
                  <td>
                    <router-link :to="'/positions/'+item.id">
                      <span>
                        {{item.service_id}}
                      </span>
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="'/positions/'+item.id">
                      <span>
                        {{item.name}}
                      </span>
                    </router-link>
                  </td>
                  <td>{{item.human_type}}</td>

                  <!--
                  <td>
                    <router-link :to="'/positions/'+item.id">
                      <span>
                        {{item.vendor_code}}
                      </span>
                    </router-link>
                  </td>
                  <td>
                    <StatesBadge
                      :item="item"
                      :state="item.state"
                      :transitions="item.transitions"
                    >
                    </StatesBadge>
                  </td>
                -->
                  <td>
                    <span v-if="item.component != 'category'">{{item.price_cents | money}}</span></td>
                  <!--<td>
                    <span v-if="item.filters">
                      <span class="badge badge-pill badge-light mr-1 text-uppercase" v-for="filters in item.filters">
                        {{filters.name}}
                      </span>
                    </span>
                  </td>-->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    items: function(){
      return this.$parent.items || []
    }
  },
  methods: {
    save(item){
      this.$parent.save(item)
    }
  }
}
</script>
